import Box from 'components/layouts/Box';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';
import { AdminSystemLocaleDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStateContext } from 'providers/usePageState';

const PolicyMenus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [languages, setLanguages] = useState<AdminSystemLocaleDto[]>([]);
  const { receiver } = useStateContext();

  const fetchLanguages = async () => {
    ServiceHelper.adminLocaleService?.getLocales1().then((res) => {
      setLanguages(res.data as AdminSystemLocaleDto[]);
    });
  };

  const routes = [
    { route: `/admin/policies/refund`, name: '환불정책', children: '' },
    {
      route: `/admin/policies/member`,
      name: '회원등급 정책',
    },
    {
      route: `/admin/policies/point`,
      name: '포인트 정책',
    },
  ];

  useEffect(() => {
    fetchLanguages();
  }, []);

  useEffect(() => {
    if (receiver?.id === 'reload' && receiver?.param === 'language') {
      fetchLanguages();
    }
  }, [receiver]);

  return (
    <div>
      <Row justifyContent="flex-start" padding="20px 0">
        <>설정</>
      </Row>
      <Row gap={10} flexDirection="column" width="100%">
        {routes.map((route) => (
          <div key={route.route} style={{ width: '300px' }}>
            <Box
              title={route.name}
              selected={location.pathname === route.route}
              onClick={() => navigate(route.route)}
            >
              <Text type="H5" buttonRole="DESCRIPTION">
                {route.children}
              </Text>
            </Box>
          </div>
        ))}
      </Row>
    </div>
  );
};

export default PolicyMenus;
